import React, { useState, useEffect } from "react";
import Header from "../Component/Header";
import { Link } from "react-router-dom";
const AchievementsData = () => {
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li>Achievements Data </li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row achievementli archivedata">
            <div className="col-lg-12">
              <h6>2023-2024</h6>
              <ul className="list">
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2404160921-1575771326-1.pdf"
                    target="_blank"
                  >
                    {" "}
                    Mukhyamantri Vigyan Pratibha Pariksha (Mvpp) 2023-2024{" "}
                  </Link>
                </li>

                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2305010900-1931835018-1.pdf"
                    target="_blank"
                  >
                    Chemistry Turncoat Debate - DPS RK PURAM{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2305041017-1188735765-1.pdf"
                    target="_blank"
                  >
                    PHDCCI WATER CONCLAVE{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2305090901-1115166085-1.pdf"
                    target="_blank"
                  >
                    Delhi State Junior Basketball Championship 2023-24{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2305171418-0441068564-1.pdf"
                    target="_blank"
                  >
                    PULSE 2023 - Bal Bharati Public School, Gangaram Hospital
                    Marg{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2305262025-1389468127-1.pdf"
                    target="_blank"
                  >
                    MUKHYAMANTRI VIGYAN PRATIBHA PARIKSHA (MVPP) 2022-2023{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2306060946-1683145643-1.pdf"
                    target="_blank"
                  >
                    Taekwondo District level Championship 2023-24{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2307220839-1181493839-1.pdf"
                    target="_blank"
                  >
                    CONFLUENCE 2023 , Air Force Golden Jubilee Institute{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2307280926-0713003164-1.pdf"
                    target="_blank"
                  >
                    Fabrication De Sculpture - Gyan Mandir Public School, Naraina
                    Vihar{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2307280926-0713003164-2.pdf"
                    target="_blank"
                  >
                    Maths Mausoleum - Gyan Mandir Public School ,Naraina Vihar{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2307281156-0135658873-1.pdf"
                    target="_blank"
                  >
                    ‘Comm-Hasya: A standup comedy performance’ - Army Public School,
                    Shankar Vihar{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2307310840-0414186135-1.pdf"
                    target="_blank"
                  >
                    Abhigyan Ojha - Sub Junior Basketball Tournament{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2308010917-1448985250-1.pdf"
                    target="_blank"
                  >
                    Science fest ‘SCIENTASTIC,’ New Era Public School, Mayapuri{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2308030957-1898836023-1.pdf"
                    target="_blank"
                  >
                    Zonal Competition - Collage Making (Visual Arts){" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2308041225-0580624836-1.pdf"
                    target="_blank"
                  >
                    Zonal Competition - Sculpture Making{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2308041356-1643476710-1.pdf"
                    target="_blank"
                  >
                    Rangrez - Tagore International School , Vasant Vihar{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2308051302-1344237792-1.pdf"
                    target="_blank"
                  >
                    International Mathematics Olympiad And National Science Olympiad
                    - Jr Wing{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2308081043-0642374679-1.pdf"
                    target="_blank"
                  >
                    Zonal Music Competition{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2308161433-0308050183-1.pdf"
                    target="_blank"
                  >
                    Zonal Mini Boys Basketball{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2308171129-1908547431-1.pdf"
                    target="_blank"
                  >
                    Inter-school Skating Championship{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2308171139-0806816752-1.pdf"
                    target="_blank"
                  >
                    Zonal Bagpipes Band Competition{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2308180854-1839810622-1.pdf"
                    target="_blank"
                  >
                    Oratoria 2023, Loreto School, Delhi Cantt{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2308210850-0960915845-1.pdf"
                    target="_blank"
                  >
                    Indian Air Force Quiz{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2308210853-1343537366-1.pdf"
                    target="_blank"
                  >
                    Articles Published in the Newspaper{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2308240945-1277573016-1.pdf"
                    target="_blank"
                  >
                    AFFWA Declamation Competition{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2310120951-1105781062-1.pdf"
                    target="_blank"
                  >
                    BEST SCHOOL IN ACADEMICS 2022-23 (SENIOR SECONDARY LEVEL){" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2308241012-0850310487-1.pdf"
                    target="_blank"
                  >
                    Zonal Sub Junior Boys Basketball Championship 2023-24{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2308241012-1796667686-1.pdf"
                    target="_blank"
                  >
                    Zonal Sub Junior Girls Basketball Championship 2023-24{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2308260841-1801798245-1.pdf"
                    target="_blank"
                  >
                    VIBRATIONS 2023{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2308291243-1532237200-1.pdf"
                    target="_blank"
                  >
                    Robo Race Competition, APS Dhaula Kuan{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2309010935-1473470867-1.pdf"
                    target="_blank"
                  >
                    Yog Udyyam 2023, The Shri Ram School, Gurugram{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2309110855-1657260977-1.pdf"
                    target="_blank"
                  >
                    Zonal Mini Lawn Tennis Girls 2023{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2309130922-0573966045-1.pdf"
                    target="_blank"
                  >
                    Zonal Mini Volleyball Tournament Girls 2023{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2309161025-0638630107-1.pdf"
                    target="_blank"
                  >
                    Zonal Sub Junior and Senior Girls Tennis Championship{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2309261115-0660443129-1.pdf"
                    target="_blank"
                  >
                    Zonal Volleyball Championship (Boys) 2023-24{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2309191300-1421724758-1.pdf"
                    target="_blank"
                  >
                    Zonal Mini Athletic Event Girls 2023{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2309201027-1078853308-1.pdf"
                    target="_blank"
                  >
                    Goenkan Grandeur, GD Goenka School, Vasant Kunj{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2309210823-1856439331-1.pdf"
                    target="_blank"
                  >
                    31st A.C. Deb Memorial interschool Oration Contest, Cambridge
                    School, Srinivaspuri{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2309260841-0926976168-1.pdf"
                    target="_blank"
                  >
                    Zonal Mini Athletic Event- Boys{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2309260843-0863453011-1.pdf"
                    target="_blank"
                  >
                    Zonal Football Championship 2023-24: Sub Junior & Junior
                    Boys{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2309260845-1051386418-1.pdf"
                    target="_blank"
                  >
                    12th All India Air Force Inter Command Sports & Athletic Meet
                    2023-24{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2310030851-1378658313-1.pdf"
                    target="_blank"
                  >
                    Sub Junior Boys National Football Championship{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2310071207-0124257674-1.pdf"
                    target="_blank"
                  >
                    TIMES SCHOOL SURVEY 2023{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2310141238-1328612471-1.pdf"
                    target="_blank"
                  >
                    13 students have cleared the written exam of NDA II 2023{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2310111444-0128451818-1.pdf"
                    target="_blank"
                  >
                    Speed Skating Event (RSFI), Roller Skating Federation of
                    India{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2310140850-1200125617-1.pdf"
                    target="_blank"
                  >
                    Zonal Mini Badminton Tournament Girls 2023{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2310171451-0693010055-1.pdf"
                    target="_blank"
                  >
                    District Level Band Competition{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2310180918-1189371557-1.pdf"
                    target="_blank"
                  >
                    Chemistry-Ionista, Annual Fest 2023, DPS Dwarka{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2310201424-1639841191-1.pdf"
                    target="_blank"
                  >
                    District Level Semi Classical Music Competition{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2310251224-1407352022-1.pdf"
                    target="_blank"
                  >
                    Delhi State School Games (Football){" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2310251443-1671203744-1.pdf"
                    target="_blank"
                  >
                    District Level Collage Making Competition{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2310261056-1295503898-1.pdf"
                    target="_blank"
                  >
                    Mandala Making Competition, DPS DWARKA{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2310261058-1322531315-1.pdf"
                    target="_blank"
                  >
                    Aqua Jet - Physics event, DPS Dwarka{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2310311022-0833540937-1.pdf"
                    target="_blank"
                  >
                    CBSE Centre Zone (Delhi Region) Skating Tournament 2023{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2310311024-1763390665-1.pdf"
                    target="_blank"
                  >
                    CBSE Central Zone (Delhi Region) Tennis Championship
                    2023-24{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2311061212-0083728954-1.pdf"
                    target="_blank"
                  >
                    CBSE Central Zone Taekwondo Championship 2023-24{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2311240900-1594546274-1.pdf"
                    target="_blank"
                  >
                    Hindi Debate Competition, Ramjas School{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2311280849-0044984913-1.pdf"
                    target="_blank"
                  >
                    CBSE National Roller Skating Championship 2023-24{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2311281418-1368889456-1.pdf"
                    target="_blank"
                  >
                    English Debate Competition, Ramjas School{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2311281424-1828164126-1.pdf"
                    target="_blank"
                  >
                    Kala Utsav District Level Vocal Music Traditional Folk
                    Competition{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2311281426-0328604204-1.pdf"
                    target="_blank"
                  >
                    Kala Utsav District Level 3D Sculpture Making Competition{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2312061328-1958828256-1.pdf"
                    target="_blank"
                  >
                    On The Spot Painting Competition:RAMJAS SCHOOL{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2312080830-0366885566-1.pdf"
                    target="_blank"
                  >
                    Zonal Level Science Exhibition{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2312080839-1148791183-1.pdf"
                    target="_blank"
                  >
                    Zonal Science Exhibition 2023 (Slogan Writing & Poster Making
                    Competition){" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2312111328-0397653232-1.pdf"
                    target="_blank"
                  >
                    Meritorious Students Award Ceremony : Class X students of
                    Academic Session 2022-23 in subject Hindi{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2312130907-1939270263-1.pdf"
                    target="_blank"
                  >
                    Zonal Project Voices Competition (DOE){" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2312141336-1140175969-1.pdf"
                    target="_blank"
                  >
                    LITERARIUM 2023, Delhi Public School, Vasant Vihar{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2312151206-0168506336-1.pdf"
                    target="_blank"
                  >
                    Zonal Project Voices Competition (DOE) - Hindi debate{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2312151209-0015678359-1.pdf"
                    target="_blank"
                  >
                    Delhi State School Games (Basketball) 2023-24{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2312151215-1306303507-1.pdf"
                    target="_blank"
                  >
                    Delhi State School Games (Football) 2023-24{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2312151220-1434817432-1.pdf"
                    target="_blank"
                  >
                    Triental Cup (Football) 2023-24{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2312181317-0616845561-1.pdf"
                    target="_blank"
                  >
                    Zonal Poetry Recitation Competition{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2312211241-0361537402-1.pdf"
                    target="_blank"
                  >
                    61st National Roller Skating Championship 2023{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2401090918-1571231652-2.pdf"
                    target="_blank"
                  >
                    4th Fr. Thomas Thoomkuzhy Memorial Basketball Tournament
                    2023-24{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2401090918-1571231652-1.pdf"
                    target="_blank"
                  >
                    27th Fr. Peter Mermier Memorial Football Tournament 2023{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2401091259-0076347801-1.pdf"
                    target="_blank"
                  >
                    International Hindi Olympiad{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2401120915-0786959052-1.pdf"
                    target="_blank"
                  >
                    67th National School Games Basketball Championship (Sub
                    Junior){" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2401241226-0036786807-1.pdf"
                    target="_blank"
                  >
                    Ramanujan 2023 - Bal Bharati Public School NTPC Khargone{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2402061228-2016361824-1.pdf"
                    target="_blank"
                  >
                    Garden Festival -Cambridge school Srinivaspuri{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2402081129-1416235660-1.pdf"
                    target="_blank"
                  >
                    Twinning Cultural Exchange Under Samagra Shiksha{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2402131458-1600080398-1.pdf"
                    target="_blank"
                  >
                    Skating Competition, K R Mangalam World School, Gurugram{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2402161043-0061294203-1.pdf"
                    target="_blank"
                  >
                    Vasantotsav, Ahlcon International School, Mayur Vihar{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2402161043-1112957144-1.pdf"
                    target="_blank"
                  >
                    Y Kumar Memorial Essay Writing & Quiz Competition, Springdales
                    School, Pusa Road{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2402161451-0610130812-1.pdf"
                    target="_blank"
                  >
                    Literary Fiesta 2023, Bal Bharati Public School NTPC Khargone
                    (Online){" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2402171430-0132372313-1.pdf"
                    target="_blank"
                  >
                    11th TAFS MINI FOOTBALL TOURNAMENT (BOYS) & 6th TAFS MINI
                    BASKETBALL TOURNAMENT (BOYS & GIRLS){" "}
                  </Link>
                </li>
              </ul>
              <h6>2022-2023</h6>
              <ul className="list">
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_297.pdf?vlii4"
                    target="_blank"
                  >
                    HT PACE Inter School Art Competition{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_298.pdf?cnvKd"
                    target="_blank"
                  >
                    MUKHYAMANTRI VIGYAN PRATIBHA PARIKSHA (MVPP) - 2021-2022{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_299.pdf?gpcgk"
                    target="_blank"
                  >
                    Poetry Out Loud Competition{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_300.pdf?lrazq"
                    target="_blank"
                  >
                    Expressions 2022 - Army Public School Shankar Vihar{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_301.pdf?1dmgc"
                    target="_blank"
                  >
                    Pulse 2022, Bal Bharati Public School, Gangaram{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/bny-wcp-2407181020-1610055248.pdf"
                    target="_blank"
                  >
                    7th Grand Open National Taekwondo Championship 2022{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_302.pdf?beJvz"
                    target="_blank"
                  >
                    Zonal Competition 2022 – Poetry Recitation (Hindi) – Suraj Bhan
                    DAV Public School, Vasant Vihar{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_303.pdf?0uJp4"
                    target="_blank"
                  >
                    Mini Zonal Basketball Tournament (Boys){" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_304.pdf?QaiJP"
                    target="_blank"
                  >
                    “Zonal Hindi Speech Competition” Army Public School, Delhi
                    Cantt{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/bny-wcp-2407181020-2059641948.pdf"
                    target="_blank"
                  >
                    Zonal Junior Boys Basketball Championship 2022-23{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_305.pdf?0eGI0"
                    target="_blank"
                  >
                    IGNITED MINDS 2022, INDRAPRASTHA INTERNATIONAL SCHOOL,
                    DWARKA{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_306.pdf?orASU"
                    target="_blank"
                  >
                    Zonal Declamation Competition, Army Public School Delhi
                    Cantt{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_308.pdf?AaJfV"
                    target="_blank"
                  >
                    Zonal Debate Competition in the Jr. Girls category, Army Public
                    School, Delhi Cantt{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_309.pdf?Fr3SW"
                    target="_blank"
                  >
                    Zonal Classical Vocal Music, Army Public School, Shankar
                    Vihar{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_313.pdf?HVspr"
                    target="_blank"
                  >
                    Zonal Visual Arts{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_311.pdf?CqgWr"
                    target="_blank"
                  >
                    Zonal Athletics Competition 2022-23{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_312.pdf?CgbHO"
                    target="_blank"
                  >
                    Agaaz 2022, Bal Bharti Public School, NTPC Khargone{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/bny-wcp-2407181020-1902800857.pdf"
                    target="_blank"
                  >
                    South & West India Taekwon-do Championship 2022{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/bny-wcp-2407181020-1094919446.pdf"
                    target="_blank"
                  >
                    Zonal Senior Boys Football Championship 2022-23{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_316.pdf?4sAbe"
                    target="_blank"
                  >
                    Expressions 2022, Army Public School, Shankar Vihar{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_315.pdf?Qv4Jd"
                    target="_blank"
                  >
                    Zonal - Semi Classical Vocal Music , Army Public School, Shankar
                    Vihar{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/bny-wcp-2407181020-0399434710.pdf"
                    target="_blank"
                  >
                    Zonal Volleyball Tournament 2022-23{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_317.pdf?TKF8e"
                    target="_blank"
                  >
                    Expressions 2022, Army Public School, Shankar Vihar (Jr
                    School){" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_318.pdf?JvJuO"
                    target="_blank"
                  >
                    Zonal Badminton Tournament 2022-23{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/bny-wcp-2407181020-1806821092.pdf"
                    target="_blank"
                  >
                    Zonal Athletics Meet 2022-23 - Sr School{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/bny-wcp-2407181020-1118427289.pdf"
                    target="_blank"
                  >
                    Subroto Cup 2022-23 (Under17 Boys): TAFS Vs. BANGLADESH{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/bny-wcp-2407181020-2106657634.pdf"
                    target="_blank"
                  >
                    Zonal Sub Junior Girls Badminton Championship 2022-23{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/bny-wcp-2407181020-2137088297.pdf"
                    target="_blank"
                  >
                    Delhi State Sub Junior Basketball Championship 2022-23{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_319.pdf?aXfcL"
                    target="_blank"
                  >
                    CYBER BUZZ 2022, Amity International School, Sec-43,
                    Gurugram{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_320.pdf?8VFvH"
                    target="_blank"
                  >
                    Kavya Samelan , New Era Public School, Mayapuri{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_321.pdf?KtfWM"
                    target="_blank"
                  >
                    Rendezvous 2022 - 'Aatmaabhivyakti', Air Force Bal Bharti
                    School, Lodi Road{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_322.pdf?5w7Im"
                    target="_blank"
                  >
                    Rendezvous 2022 - 'Hartes Zeug', Air Force Bal Bharti School,
                    Lodi Road{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_323.pdf?Mc5Ar"
                    target="_blank"
                  >
                    Kala Utsav 2022, District Level Competition{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_324.pdf?5tusd"
                    target="_blank"
                  >
                    Annual Organ Donation Poster Making Competition, Nehru
                    Planetarium{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_325.pdf?hRLBp"
                    target="_blank"
                  >
                    Vibrations-2022 , Birla Vidya Niketan School{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/bny-wcp-2407181020-1209719278.pdf"
                    target="_blank"
                  >
                    26th Fr. Peter Mermier Memorial Football Tournament 2022{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/bny-wcp-2407181020-2010677869.pdf"
                    target="_blank"
                  >
                    St. Francis De Sales Memorial Basketball Tournament 2022-23{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_330.pdf?PBujM"
                    target="_blank"
                  >
                    Zonal Science Debate{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_326.pdf?Fp0FO"
                    target="_blank"
                  >
                    Zonal Science Quiz{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_327.pdf?L1ZVf"
                    target="_blank"
                  >
                    All India Karate Championship{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_328.pdf?Trv3p"
                    target="_blank"
                  >
                    CBSE Adolescent Summit on Life Skills, Mental Health, Safety and
                    Well Being{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_332.pdf?J7O6M"
                    target="_blank"
                  >
                    Kalavrind 2022- Delhi police public school, SJ Enclave{" "}
                  </Link>
                  ,{" "}
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2302171100-1516230785-1.pdf"
                    target="_blank"
                  >
                    BEST SCHOOL TROPHY{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_333.pdf?YnVbv"
                    target="_blank"
                  >
                    37th National Taekwondo- Do ITF Championship{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/wcp-2304281355-0649212909-1.pdf"
                    target="_blank"
                  >
                    National Essay Writing Competition{" "}
                  </Link>
                </li>
              </ul>
              <h6>2021-2022</h6>
              <ul className="list">
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_241.pdf?VG8rf"
                    target="_blank"
                  >
                    Mukhyamantri Vigyan Pratibha Pariksha (MVPP) exam-2020-21{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_245.pdf?CwCgW"
                    target="_blank"
                  >
                    Eco-Fest 2021 by Bhumi{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_243.pdf?ZTppl"
                    target="_blank"
                  >
                    Mathability 2021, Gyan Bharati School, Saket{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_246.pdf?nGwGs"
                    target="_blank"
                  >
                    Anveshan & Mathemania, Gyan Bharti School, Saket{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_247.pdf?7fHMt"
                    target="_blank"
                  >
                    Renaissance 2021, St. Xavier's High School, Greater Noida{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_248.pdf?SH1da"
                    target="_blank"
                  >
                    Arthashastra and Confest 21, DPS, VK{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_249.pdf?ILu1Z"
                    target="_blank"
                  >
                    All India School Paryavaran Competition (AISPC) 2021{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_250.pdf?AFi0s"
                    target="_blank"
                  >
                    Interact 2021. Mount Carmel School, Anand Niketan{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_251.pdf?57Vo4"
                    target="_blank"
                  >
                    It Pictura Poesis, Gyan Bharti School, Saket{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_252.pdf?p3ZUr"
                    target="_blank"
                  >
                    COM CONCLAVE 2021, Gyan Bharti School, Saket{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_253.pdf?kPAHr"
                    target="_blank"
                  >
                    Interact 2021. Mount Carmel School{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_254.pdf?mn7Hv"
                    target="_blank"
                  >
                    CBSE - Certificate of Merit : Senior School Certificate
                    Examination 2020{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_256.pdf?5TMop"
                    target="_blank"
                  >
                    Live Comic Act – Army Public School, Shankar Vihar{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_257.pdf?Ay1Ht"
                    target="_blank"
                  >
                    Rendezvous – 2021, Air Force Bal Bharati School, Lodhi Road{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_258.pdf?7i1PR"
                    target="_blank"
                  >
                    CBSE - Certificate of Merit : Secondary School Examination
                    2020{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_261.pdf?eXFUp"
                    target="_blank"
                  >
                    Genesis - Diagnostic Competition DPS Dwarka{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_262.pdf?D5kHF"
                    target="_blank"
                  >
                    Science Debate-St. Marks School{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_263.pdf?pKq1j"
                    target="_blank"
                  >
                    AROMA 2021, Delhi Police Public School, Safdarjung Enclave{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_264.pdf?cFex1"
                    target="_blank"
                  >
                    VAASTUKALA MEIN GANIT-St Marks School{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_265.pdf?57mJi"
                    target="_blank"
                  >
                    Exploring Mass In Physics{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_266.pdf?ETxJP"
                    target="_blank"
                  >
                    Ganit ki Bhasha-St. Marks Senior Secondary School{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_267.pdf?NttU0"
                    target="_blank"
                  >
                    Trash Treasure-Anubhav 2021{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_268.pdf?Qk0Oo"
                    target="_blank"
                  >
                    Vigyanshala -St. Mark Sr. Sec Public school{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_269.pdf?wQJM3"
                    target="_blank"
                  >
                    Yantra Mantra - St. Mark Sr. Sec Public school{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_270.pdf?4BRVi"
                    target="_blank"
                  >
                    Words on Wings – A Poem Writing Competition{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_271.pdf?BsuNh"
                    target="_blank"
                  >
                    Glimpses 2021, N.K Bagrodia Public School, Dwarka{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_276.pdf?kxO5c"
                    target="_blank"
                  >
                    Poster Making Competition, DPS Dwarka{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_277.pdf?H41Yb"
                    target="_blank"
                  >
                    Tinker Fest 2021{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_273.pdf?UwPQT"
                    target="_blank"
                  >
                    Code Breakers Competition{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_278.pdf?8ddf4"
                    target="_blank"
                  >
                    Kala Utsav 2021{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_279.pdf?of6cl"
                    target="_blank"
                  >
                    Science Fest – The Catalyst, Dav Public School Gurugram{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_280.pdf?dN59M"
                    target="_blank"
                  >
                    Melange 2021, Adharshilla Vidyapeeth{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_281.pdf?3A83t"
                    target="_blank"
                  >
                    Utsav 2021, Indraprstha Global School{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_282.pdf?sqETt"
                    target="_blank"
                  >
                    Chem O Motion….. The Mole Day{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_283.pdf?jeb7L"
                    target="_blank"
                  >
                    ASTERISM – Astronomy Quiz{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_284.pdf?jN8fj"
                    target="_blank"
                  >
                    Trust of India Cartoon Caption Contest{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_285.pdf?FHRmF"
                    target="_blank"
                  >
                    IIT Madras - Shaastra Junior{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_286.pdf?ngGEr"
                    target="_blank"
                  >
                    RENAISSANCE 2021-Vivekanand Public School, Anand Vihar{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_287.pdf?i1RGS"
                    target="_blank"
                  >
                    Inter School Sports Events 2021{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_288.pdf?T4AR5"
                    target="_blank"
                  >
                    Are you Ready , Birla Vidya Niketan{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_290.pdf?bfDsi"
                    target="_blank"
                  >
                    Bro. Bergin Music Event- Mount St. Mary’s School{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_289.pdf?yp8wU"
                    target="_blank"
                  >
                    Insight-indus Valley Public School, Noida{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_291.pdf?vzbQm"
                    target="_blank"
                  >
                    VASANTOTSAV 2022, Ahlcon International school, Mayur Vihar{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_292.pdf?pZXwG"
                    target="_blank"
                  >
                    SOF - International English Olympiad (Sr School) 2021-22{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_293.pdf?zqLV3"
                    target="_blank"
                  >
                    SOF - International English Olympiad (Jr School) 2021-22{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_294.pdf?gXBXp"
                    target="_blank"
                  >
                    VISTAAR 2022- CRPF Public School, Rohini{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_295.pdf?F1g8a"
                    target="_blank"
                  >
                    SOF - International Mathematics Olympiad 2021-22{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_296.pdf?RGucz"
                    target="_blank"
                  >
                    SOF - National Cyber Olympiad 2021-22{" "}
                  </Link>
                </li>
              </ul>
              <h6>2020-2021</h6>
              <ul className="list">
                <li>
                  {" "}
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_172.pdf?InDxb"
                    target="_blank"
                  >
                    AROMA 2020, AN ONLINE INTER-SCHOOL LANGUAGE FEST HOSTED BY DELHI
                    POLICE PUBLIC SCHOOL{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_173.pdf?gdXkd"
                    target="_blank"
                  >
                    INTER- SCHOOL COMPETITION - 'QUARANTINE KHOJ 2020'{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_175.pdf?pqZZA"
                    target="_blank"
                  >
                    SPECIAL ACHIEVEMENTS{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_177.pdf?qOEdR"
                    target="_blank"
                  >
                    23RD GREENS TO GLORY JUNIOR GOLF TOURNAMENT - S LAKSHITA
                    PRAGNYA{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_178.pdf?6Qnrl"
                    target="_blank"
                  >
                    RENAISSANCE 2020, NEW ERA PUBLIC SCHOOL, DWARKA{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_179.pdf?KOU1z"
                    target="_blank"
                  >
                    PLENARY SESSION-GLOBAL SUMMIT ON UN SDGS 2020, ASN SR. SEC.
                    SCHOOL, MAYUR VIHAR{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_180.pdf?jOTw7"
                    target="_blank"
                  >
                    FANTASIA 2020, ADARSH PUBLIC SCHOOL{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_181.pdf?k3OI5"
                    target="_blank"
                  >
                    VED VYAS SCHOOL, VIKASPURI{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_182.pdf?f4RES"
                    target="_blank"
                  >
                    INTERSCHOOL EVENT – RENDEZVOUS 2020 (JR SCHOOL){" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_183.pdf?dcmBi"
                    target="_blank"
                  >
                    INTERSCHOOL EVENT – RENDEZVOUS 2020 (SR SCHOOL){" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_184.pdf?UsqtO"
                    target="_blank"
                  >
                    EK BHARAT SHRESTH BHARAT, ST. THOMAS SCHOOL{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_185.pdf?N6uQL"
                    target="_blank"
                  >
                    VIBRANT INDIA 2020 , ASN SENIOR SECONDARY SCHOOL, MAYUR
                    VIHAR{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_186.pdf?dOgSU"
                    target="_blank"
                  >
                    SCHOOL SUPER LEAGUE{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_187.pdf?hvhqL"
                    target="_blank"
                  >
                    HIGHER TRAJECTORIES 2020, ARMY PUBLIC SCHOOL, SHANKAR VIHAR{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_188.pdf?vKubE"
                    target="_blank"
                  >
                    TAPS FEST “COALESCE 2020" , ARMY PUBLIC SCHOOL, DHAULA KUAN{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_189.pdf?EKuy2"
                    target="_blank"
                  >
                    EXPRESSIONS 2020, ARMY PUBLIC SCHOOL, SHANKAR VIHAR{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_190.pdf?WSJX4"
                    target="_blank"
                  >
                    3KM VIRTUAL RUN (FIT INDIA FREEDOM RUN){" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_191.pdf?6uImb"
                    target="_blank"
                  >
                    CLAT - 2020{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_192.pdf?PWnXt"
                    target="_blank"
                  >
                    INNOVATIVE AND SUSTAINABLE IDEA COMPETITION{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_193.pdf?n1sj8"
                    target="_blank"
                  >
                    KAVITA PRAKASHAN - MS SHRUTI, TGT-HINDI{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_194.pdf?xrOhX"
                    target="_blank"
                  >
                    DIGILOGOUS 7.0, RUKMINI DEVI PUBLIC SCHOOL, PITAMPURA{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_196.pdf?9nzoa"
                    target="_blank"
                  >
                    BAL BHARATI PUBLIC SCHOOL, GRH MARG{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_197.pdf?GApjG"
                    target="_blank"
                  >
                    SPECIAL ACHIEVERS: SOF – OLYMPIADS (2019 - 2020){" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_198.pdf?J9cZ1"
                    target="_blank"
                  >
                    BERSERKA 2020 : JOURNALISM 101{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_199.pdf?Ejmm9"
                    target="_blank"
                  >
                    BERSERKA 2020 : TALK THE TALK{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_200.pdf?TcVGU"
                    target="_blank"
                  >
                    BERSERKA 2020 : ELOQUENT ART{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_201.pdf?yoNZA"
                    target="_blank"
                  >
                    IQF MONOACTING : AIR FORCE GOLDEN JUBILEE INSTITUTE{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_202.pdf?m341Q"
                    target="_blank"
                  >
                    THE CATALYST : DAV PUBLIC SCHOOL SECTOR14 GURUGRAM{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_203.pdf?LxZbH"
                    target="_blank"
                  >
                    THE CATALYST (LIVES OF GREAT SCIENTIST) : DAV PUBLIC SCHOOL
                    SECTOR14 GURUGRAM{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_204.pdf?G18xk"
                    target="_blank"
                  >
                    ANNUAL TECH EVENT-TECH BUZZ 2020, DAV PUBLIC SCHOOL,
                    GURUGRAM{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_205.pdf?uixLi"
                    target="_blank"
                  >
                    MUSCLE WITH BRAINS – DESIGNING A DREAM HOUSE, BIRLA VIDYA
                    NIKETAN{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_206.pdf?IQBwe"
                    target="_blank"
                  >
                    ONLINE PROGRAMMING COMPETITION, MOUNT ST. MARY’S SCHOOL,DELHI
                    CANTT{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_207.pdf?4XSRl"
                    target="_blank"
                  >
                    ONLINE INTER-SCHOOL COMPETITION, MOUNT ST. MARY SCHOOL,DELHI
                    CANTT{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_208.pdf?LLgPK"
                    target="_blank"
                  >
                    GEETANJALI FEST 2020{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_209.pdf?N5LmK"
                    target="_blank"
                  >
                    ONLINE ROPE SKIPPING COMPETITION{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_210.pdf?7aTG3"
                    target="_blank"
                  >
                    “MINECLASS” , DELHI PUBLIC SCHOOL, GHAZIABAD{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_211.pdf?rguft"
                    target="_blank"
                  >
                    30TH INTER PUBLIC SCHOOL ENGLISH DEBATE COMPETITION{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_212.pdf?PUjKF"
                    target="_blank"
                  >
                    “PUTHON CODEX” , DELHI PUBLIC SCHOOL, GHAZIABAD{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_213.pdf?C77YP"
                    target="_blank"
                  >
                    CREATAL 2020 - INTERSCHOOL COMPETITION AT DPS GHAZIABAD{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_214.pdf?fZN26"
                    target="_blank"
                  >
                    MONOLOGUE, CAMBRIDGE SCHOOL, INDIRAPURAM{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_215.pdf?NcBa9"
                    target="_blank"
                  >
                    ANNUAL INTER- SCHOOL ART AND POETRY COMPETITION ‘STROKES AND
                    STANZAS 2020’{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_216.pdf?av6sM"
                    target="_blank"
                  >
                    SOLO SINGING, MOUNT ST MARY'S SCHOOL, DELHI CANTT{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_217.pdf?DDLhq"
                    target="_blank"
                  >
                    KAUMARAM PRASHANTHI ACADEMY ART CONTEST 2020{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_218.pdf?VlHOg"
                    target="_blank"
                  >
                    DPS DWARKA, INTERSCHOOL EVENT – MELANGE 2020{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_219.pdf?pn8EV"
                    target="_blank"
                  >
                    CBSE EXPRESSION SERIES ON ART AND CULTURE - DECEMBER 2020{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_220.pdf?Bawtf"
                    target="_blank"
                  >
                    AASHAYEIN 2020 - SCIENCE COMPETITION : YOUNG TECH INNOVATOR{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_221.pdf?3mfQm"
                    target="_blank"
                  >
                    AASHAYEIN 2020 - ON THE WINGS OF HOPE{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_222.pdf?iEbN6"
                    target="_blank"
                  >
                    AASHAYEIN 2020 : LITERARY COMPETITION- QUOD SPECTAT – THE YOUNG
                    ORATORS’{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_223.pdf?ykbcM"
                    target="_blank"
                  >
                    AASHAYEIN 2020 : THEMATIC JINGLE COMPETITION{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_224.pdf?uqFWb"
                    target="_blank"
                  >
                    AASHAYEIN 2020 : QUOD SPECTAT{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_230.pdf?iX5Hi"
                    target="_blank"
                  >
                    AASHAYEIN 2020 - TREIANGLE MAZE{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_225.pdf?dTeWR"
                    target="_blank"
                  >
                    WAR OF WORDS: ADHARSHEELA GLOBAL SCHOOL, VASUNDHARA{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_226.pdf?vpUqh"
                    target="_blank"
                  >
                    AASHAYEIN 2020 - MELOPHILES-SOLO SINGING COMPETITION{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_227.pdf?fz2KD"
                    target="_blank"
                  >
                    S JAHNAVI PRAKHYA (CLASS XII D){" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_229.pdf?I55lj"
                    target="_blank"
                  >
                    IGNITE 2020-21, DPS JAIPUR{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_231.pdf?QXfIq"
                    target="_blank"
                  >
                    INTERSCHOOL ONLINE AEROBICS COMPETITION – BIRLA VIDYA
                    NIKETAN{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_232.pdf?5gGdL"
                    target="_blank"
                  >
                    SOF – INTERNATIONAL GENERAL KNOWLEDGE OLYMPIAD (2020 -
                    2021){" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_233.pdf?NvNDc"
                    target="_blank"
                  >
                    MERAKI 2021 - ST. SOLDIER'S SCHOOL, PANCHKULA{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_234.pdf?0hLtD"
                    target="_blank"
                  >
                    FIESTA - ‘SPINNING CHALLENGES’ AT DPS VASANT VIHAR{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_235.pdf?wxFjm"
                    target="_blank"
                  >
                    NATIONAL SCIENCE DAY, MANIPAL UNIVERSITY JAIPUR{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_236.pdf?ZJYdF"
                    target="_blank"
                  >
                    IGNITE–KALEIDOSCOPE{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_237.pdf?mW9UU"
                    target="_blank"
                  >
                    BRICS MATH ONLINE COMPETITION-2020{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_238.pdf?ymsyq"
                    target="_blank"
                  >
                    TEACHERS WRITE POETRY FOR NPSC E -BOOK{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_239.pdf?JZ9Mt"
                    target="_blank"
                  >
                    HIGH ACHIEVERS IN NSO 2020-2021{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_240.pdf?skB9M"
                    target="_blank"
                  >
                    HIGH ACHIEVERS IN IMO 2020-2021{" "}
                  </Link>
                </li>
              </ul>
              <h6>2019-2020</h6>
              <ul className="list">
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_100.pdf?ttOEk"
                    target="_blank"
                  >
                    ACHIEVERS : 2ND LEVEL OLYMPIADS ( 2018 – 19) CONDUCTED BY SOF
                    FOUNDATION{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_101.pdf?mseIX"
                    target="_blank"
                  >
                    ‘ACTION FOR AUTISM’- EXHIBITION AT INDIA HABITAT CENTRE{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_102.pdf?pxfsk"
                    target="_blank"
                  >
                    UBHARTE HASTAKSHAR : ART AND LITERATURE FESTIVAL{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_103.pdf?YvYet"
                    target="_blank"
                  >
                    CONFLUENCE 2019: HERITAGE DEBATE{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_104.pdf?k3Tyq"
                    target="_blank"
                  >
                    KISHORE VAIGYANIK PROTSAHAN YOJNA EXAM{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_105.pdf?dwDBD"
                    target="_blank"
                  >
                    ABHIVYAKTI 2019 - START UP INDIA{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_106.pdf?Edx1M"
                    target="_blank"
                  >
                    ABHIVYAKTI 2019 - GREEN WALL{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_107.pdf?cMozJ"
                    target="_blank"
                  >
                    ABHIVYAKTI 2019 - BRAIN 'O' VITA{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_109.pdf?6E4US"
                    target="_blank"
                  >
                    ABHIVYAKTI 2019 -MOSAIC MAKING COMPETITION{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_108.pdf?Uvw0B"
                    target="_blank"
                  >
                    CONFLUENCE 2019 - K R MANGALAM WORLD SCHOOL{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_110.pdf?MJeR6"
                    target="_blank"
                  >
                    ‘SPIN-A-TALE’ - AIR FORCE SCHOOL, CAMERO{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_111.pdf?Wm10W"
                    target="_blank"
                  >
                    DELHI STATE BASKETBALL TOURNAMENT – 2019 (SUB-JUNIOR BOYS){" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_112.pdf?YYhri"
                    target="_blank"
                  >
                    ABHIVYAKTI 2019 AT GYAN MANDIR PUBLIC SCHOOL{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_114.pdf?Enmjc"
                    target="_blank"
                  >
                    RENDEZVOUS 2019- TETRATHLONE{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_115.pdf?ZiTKr"
                    target="_blank"
                  >
                    RENDEZVOUS 2019: RESONANCE – A TURNCOAT EXPERIENCE{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_116.pdf?MwMDc"
                    target="_blank"
                  >
                    MALHAAR 2019 - THE INDIAN SCHOOL{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_117.pdf?U7aXQ"
                    target="_blank"
                  >
                    ZONAL MINI FOOTBALL TOURNAMENT- 2019 (GIRLS){" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_118.pdf?BRTFY"
                    target="_blank"
                  >
                    ZONAL MINI LAWN TENNIS TOURNAMENT- 2019 (GIRLS){" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_120.pdf?PsCHp"
                    target="_blank"
                  >
                    ZONAL SUB JUNIOR BOYS TENNIS CHAMPIONSHIP 2019-20{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_121.pdf?IbZAm"
                    target="_blank"
                  >
                    INTER SCHOOL ENGLISH DEBATE - S D PUBLIC SCHOOL, PATEL
                    NAGAR{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_122.pdf?rVVnQ"
                    target="_blank"
                  >
                    SCIENCE AND MATHEMATICS QUEST-ST MARKS SR SECONDARY SCHOOL,
                    MEERA BAGH{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_123.pdf?5Epsj"
                    target="_blank"
                  >
                    DRAMATIC MONOLOGUE-S D PUBLIC SCHOOL, PATEL NAGAR{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_124.pdf?ysNU7"
                    target="_blank"
                  >
                    MAD ABOUT MATHS - ST MARK’S SR SEC SCHOOL, MEERA BAGH{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_125.pdf?asQTF"
                    target="_blank"
                  >
                    ANNUAL ASTRONOMY QUIZ CONTEST 2019{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_126.pdf?2kyxA"
                    target="_blank"
                  >
                    INTER SCHOOL NUKKAD NATAK AT S D PUBLIC SCHOOL{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_127.pdf?qIOCD"
                    target="_blank"
                  >
                    DDA INTERSCHOOL TENNIS CHAMPIONSHIP 2019{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_130.pdf?KLcqe"
                    target="_blank"
                  >
                    ZONAL TAEKWONDO CHAMPIONSHIP 2019-20{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_129.pdf?PIPoe"
                    target="_blank"
                  >
                    ZONAL SUB JUNIOR BOYS BASKETBALL CHAMPIONSHIP 2019-20{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_134.pdf?6SxlX"
                    target="_blank"
                  >
                    LAXMAN MEMORIAL INTERSCHOOL COMPETITION - MS- PAINT POSTER
                    MAKING{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_132.pdf?4fuv1"
                    target="_blank"
                  >
                    ZONAL LEVEL SCIENCE QUIZ COMPETITION{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_133.pdf?eGO0M"
                    target="_blank"
                  >
                    ZONAL LEVEL: MATHEMATICS EXHIBITION 2019-20{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_135.pdf?jEU7Y"
                    target="_blank"
                  >
                    NATIONAL SPORTS ACHIEVERS - BASKETBALL{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_136.pdf?a8iFD"
                    target="_blank"
                  >
                    ZONAL SENIOR BOYS BASKETBALL CHAMPIONSHIP 2019-2020{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_137.pdf?QblTD"
                    target="_blank"
                  >
                    3rd FR. THOMAS THOOMKUZY MEMORIAL BASKETBALL TOURNAMENT
                    2019-20{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_138.pdf?eNGz9"
                    target="_blank"
                  >
                    ZONAL POETRY RECITATION COMPETITION{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_139.pdf?mwMcI"
                    target="_blank"
                  >
                    SANSKRIT COMPETITION - ' laLd`r ,dy xhr xk;u izfr;ksfxrk'{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_140.pdf?1jo8G"
                    target="_blank"
                  >
                    TAPSFEST’19 : ARMY PUBLIC SCHOOL, DHAULA KUAN{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_141.pdf?yfTyC"
                    target="_blank"
                  >
                    LAXMAN PUBLIC SCHOOL - ' dkO; ikB izfr;ksfxrk'{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_142.pdf?4a2G2"
                    target="_blank"
                  >
                    ZONAL LEVEL EXTEMPORE COMPETITION{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_143.pdf?OLZM9"
                    target="_blank"
                  >
                    ZONAL HINDI ESSAY WRITING COMPETITION{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_144.pdf?WgtOv"
                    target="_blank"
                  >
                    NATIONAL PSYCHOLYMPIAD 2019{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_145.pdf?JwQEO"
                    target="_blank"
                  >
                    ZONAL COMPETITION - FINE ARTS{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_146.pdf?4s7eU"
                    target="_blank"
                  >
                    ZONAL LEVEL: MUSIC COMPETITION 2019-20{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_147.pdf?Z6xs1"
                    target="_blank"
                  >
                    ZONAL LEVEL BAND COMPETITION{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_148.pdf?sjyTS"
                    target="_blank"
                  >
                    CBSE TAEKWONDO CHAMPIONSHIP 2019-20{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_152.pdf?git9K"
                    target="_blank"
                  >
                    ALL INDIA 7TH KOREA-INDIA FRIENDSHIP ESSAY COMPETITION 2019{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_150.pdf?eKhGB"
                    target="_blank"
                  >
                    THINK SUMMIT '19, DPS RK PURAM{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_151.pdf?8Z6tU"
                    target="_blank"
                  >
                    CHETNA- NUKKAD NAATAK (AIR FORCE SCHOOL, CAMERO){" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_153.pdf?ipJsz"
                    target="_blank"
                  >
                    CBSE BASKETBALL CHAMPIONSHIP 2019-20{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_154.pdf?hqFGZ"
                    target="_blank"
                  >
                    INTER SCHOOL COMPETITION - DPS, DWARKA{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_155.pdf?qQaTE"
                    target="_blank"
                  >
                    INTERSCHOOL EVENT- LUMINARIUM 2019{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_158.pdf?flboZ"
                    target="_blank"
                  >
                    CBSE CLUSTER XX DELHI REGION ATHLETICS CHAMPIONSHIP 2019-20{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_157.pdf?jfXGA"
                    target="_blank"
                  >
                    11TH ALL INDIA AIR FORCE SCHOOLS ATHLETICS & SPORTS
                    CHAMPIONSHIP-2019{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_159.pdf?wsqzo"
                    target="_blank"
                  >
                    23RD RAHUL JOSHI MEMORIAL DECLAMATION CONTEST, SPRINGDALES
                    SCHOOL, PUSA ROAD{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_160.pdf?dJff3"
                    target="_blank"
                  >
                    INTERSCHOOL EVENT- TAGFEST 2019{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_161.pdf?HpWEQ"
                    target="_blank"
                  >
                    ZONAL JUNIOR BOYS VOLLEYBALL CHAMPIONSHIP 2019-2020{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_162.pdf?OlRU0"
                    target="_blank"
                  >
                    INTER SCHOOL WALL ART COMPETITION, MANAV BHARTI SCHOOL{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_163.pdf?gThB7"
                    target="_blank"
                  >
                    ZONAL ATHLETICS CHAMPIONSHIP 2019-20{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_164.pdf?UAn1e"
                    target="_blank"
                  >
                    EVOLVE 2K19{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_165.pdf?HK8AQ"
                    target="_blank"
                  >
                    K.G KHOSLA MEMORIAL INTER SCHOOL BASKETBALL CHAMPIONSHIP
                    2019-20{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_166.pdf?FOI8e"
                    target="_blank"
                  >
                    SRIJAN INTERSCHOOL LITERATURE FESTIVAL{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_167.pdf?F8X6b"
                    target="_blank"
                  >
                    FIESTA - THE TALENT TRAPEZE{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_169.pdf?EujFQ"
                    target="_blank"
                  >
                    YOUNG CHANGE LEADERS{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_170.pdf?XXzcP"
                    target="_blank"
                  >
                    SPELL BEE OLYMPIAD{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_171.pdf?VKZm4"
                    target="_blank"
                  >
                    ARYABHATA GANIT CHALLENGE{" "}
                  </Link>
                </li>
              </ul>
              <h6>2018-2019</h6>
              <ul className="list">
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_60.pdf"
                    target="_blank"
                  >
                    SOF NATIONAL CYBER OLYMPIAD (2017-18){" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_61.pdf"
                    target="_blank"
                  >
                    IQF ENGLISH ORATION - CONFLUENCE 2018{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_62.pdf"
                    target="_blank"
                  >
                    A – SYMMETRICAL : CONFLUENCE 2018{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_63.pdf"
                    target="_blank"
                  >
                    MILEY SUR MERA TUMHARA - AIR FORCE BAL BHARTI SCHOOL{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_64.pdf"
                    target="_blank"
                  >
                    GAB FEST - AIR FORCE BAL BHARTI SCHOOL{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_65.pdf"
                    target="_blank"
                  >
                    RESONANCE AND ROLE ROALD DAHL - AIR FORCE BAL BHARTI SCHOOL{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_66.pdf"
                    target="_blank"
                  >
                    PARIKRAMA-AIR FORCE BAL BHARTI SCHOOL{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_89.pdf"
                    target="_blank"
                  >
                    LOK KATHA - AIR FORCE BAL BHARTI SCHOOL{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_67.pdf"
                    target="_blank"
                  >
                    VALUE CREATION AND KAVYA ABHINAY - AIR FORCE BAL BHARTI
                    SCHOOL{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_68.pdf"
                    target="_blank"
                  >
                    PLANET AUTISM - SHIVAM VERMA(V C){" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://www.tafssp.com/events?enc=1p9R6z8oLEuXd6TtmyT85tneoZ/ZMeIxE4WkZxdrmCC0A1eLKfjQOU2E3p/Nxt53"
                    target="_blank"
                  >
                    COMBINE ANNUAL TRAINING CAMP (NCC GIRLS) 2018{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_82.pdf"
                    target="_blank"
                  >
                    SPECIAL ACHIEVEMENTS{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_71.pdf"
                    target="_blank"
                  >
                    ABHIVYAKTI 2018 - EXPRESS YOURSELF{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_72.pdf"
                    target="_blank"
                  >
                    KISSA GOI – THE ART OF STORY TELLING, GYAN MANDIR PUBLIC
                    SCHOOL{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/bny-wcp-2407181020-1853836778.pdf"
                    target="_blank"
                  >
                    ZONAL TAEKWONDO CHAMPIONSHIP 2018-19{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/bny-wcp-2407181020-0926467759.pdf"
                    target="_blank"
                  >
                    ZONALS SENIOR GIRLS TENNIS CHAMPIONSHIP 2018-19{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_73.pdf"
                    target="_blank"
                  >
                    PROMETHEAN FEST : MODERN SCHOOL VASANT VIHAR{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_75.pdf"
                    target="_blank"
                  >
                    ASEAN QUIZ 2018{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_76.pdf"
                    target="_blank"
                  >
                    ZONAL MINI BASKETBALL TOURNAMENT- GIRLS{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_77.pdf"
                    target="_blank"
                  >
                    ZONAL MINI BASKETBALL TOURNAMENT- BOYS{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/bny-wcp-2407181020-1308270313.pdf"
                    target="_blank"
                  >
                    ZONAL SUB JUNIOR GIRLS BASKETBALL CHAMPIONSHIP 2018-19{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/bny-wcp-2407181020-0036620336.pdf"
                    target="_blank"
                  >
                    ZONAL SUB JUNIOR BOYS BASKETBALL CHAMPIONSHIP 2018-19{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_78.pdf"
                    target="_blank"
                  >
                    ‘QRIOSITY’ AT NEW ERA PUBLIC SCHOOL{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_80.pdf"
                    target="_blank"
                  >
                    BLOOM PUBLIC SCHOOL - GANIT PAR ANMOL VACHAN{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/bny-wcp-2407181020-1331610043.pdf"
                    target="_blank"
                  >
                    2ND FR. THOMAS THOOMKUZY MEMORIAL TOURNAMENT 2018-19{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_83.pdf"
                    target="_blank"
                  >
                    TAGFEST 2018: CANVAS PAINTING COMPETITION{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_86.pdf"
                    target="_blank"
                  >
                    TAGFEST 2018 : SOUNDS OF SILENCE{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_84.pdf"
                    target="_blank"
                  >
                    20th TALENT SPORTS INTERSCHOOL ROLLER SKATING CHAMPIONSHIP -
                    2018-19{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/bny-wcp-2407181020-1294256560.pdf"
                    target="_blank"
                  >
                    TENTH ALL INDIA AIR FORCE SCHOOLS ATHLETICS & SPORTS
                    CHAMPIONSHIP 2018{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_85.pdf"
                    target="_blank"
                  >
                    AFWWA DECLAMATION CONTEST 2018{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/bny-wcp-2407181020-1556571506.pdf"
                    target="_blank"
                  >
                    ZONAL ATHLETICS CHAMPIONSHIP 2018-19{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_87.pdf"
                    target="_blank"
                  >
                    JUNIOR SCHOOL : TENNIS AND SKATING COMPETITION 2018{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_88.pdf"
                    target="_blank"
                  >
                    26TH INTER SCHOOL DEBATE COMPETITION - ST. FRANCIS DE SALES,
                    JANAK PURI{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/bny-wcp-2407181020-0516805812.pdf"
                    target="_blank"
                  >
                    CBSE CLUSTER XX DELHI REGION ATHLETICS CHAMPIONSHIP 2018-19{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/bny-wcp-2407181020-1924192194.pdf"
                    target="_blank"
                  >
                    CBSE TAEKWONDO CHAMPIONSHIP 2018-19{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/bny-wcp-2407181020-0465270463.pdf"
                    target="_blank"
                  >
                    ZONAL ATHLETICS (THROWING EVENTS) CHAMPIONSHIP 2018-19{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_90.pdf"
                    target="_blank"
                  >
                    ZONAL LEVEL SCIENCE EXHIBITION{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_93.pdf"
                    target="_blank"
                  >
                    ZONAL MINI FOOTBALL TOURNAMENT 2018- BOYS{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_92.pdf"
                    target="_blank"
                  >
                    ROLLER SKATING CHAMPIONSHIP 2018-19{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_94.pdf"
                    target="_blank"
                  >
                    RAMJAS BASKET BALL CHAMPIONS LEAGUE 2018{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_95.pdf"
                    target="_blank"
                  >
                    ZONAL MINI FOOTBALL TOURNAMENT- GIRLS{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_96.pdf"
                    target="_blank"
                  >
                    ‘RISING SPIRIT’ 2018-19 AT ARMY HOSPITAL PRIMARY SCHOOL{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_97.pdf"
                    target="_blank"
                  >
                    COMPETITION ON BOOK REVIEW, NEW ERA PUBLIC SCHOOL{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_99.pdf?xI1k1"
                    target="_blank"
                  >
                    NATIONAL ASTRONOMY CHALLENGE 2018{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_98.pdf?gY0tM"
                    target="_blank"
                  >
                    POSTER HUNT COMPETITION{" "}
                  </Link>
                </li>
              </ul>
              <h6>2017-2018</h6>
              <ul className="list">
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_41.pdf"
                    target="_blank"
                  >
                    'Abhivyakti' - Gyan Mandir Public School{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_43.pdf"
                    target="_blank"
                  >
                    Special Achievements{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_44.pdf"
                    target="_blank"
                  >
                    Interact 2017- Mount Carmel School{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_45.pdf"
                    target="_blank"
                  >
                    Confluence 2017{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_46.pdf"
                    target="_blank"
                  >
                    Utsav 2017{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_47.pdf"
                    target="_blank"
                  >
                    Zonal Music Competition{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_48.pdf"
                    target="_blank"
                  >
                    Zonal Band Competition{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_52.pdf"
                    target="_blank"
                  >
                    AFWWA Declamation Contest{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_50.pdf"
                    target="_blank"
                  >
                    Zonal Senior Boys Basketball Championship 2017-18{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/bny-wcp-2407181020-1924360307.pdf"
                    target="_blank"
                  >
                    1st Fr. Thomas Thoomkuzy Memorial Tournament 2017-18{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_51.pdf"
                    target="_blank"
                  >
                    Zonal Sub Junior Girls Badminton Championship 2017-18{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/bny-wcp-2407181020-2142062724.pdf"
                    target="_blank"
                  >
                    Zonal Sub Junior Boys Basketball Championship 2017-18{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/bny-wcp-2407181020-0376381631.pdf"
                    target="_blank"
                  >
                    Ninth All India Air Force Schools Athletics & Sports
                    Championship 2017{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/bny-wcp-2407181020-1596496259.pdf"
                    target="_blank"
                  >
                    CBSE Cluster XX Delhi Region Athletics Championship 2017-18{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/bny-wcp-2407181020-0018086920.pdf"
                    target="_blank"
                  >
                    23rd North Zone Sports Climbing Championship – 2017{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/bny-wcp-2407181020-1896332801.pdf"
                    target="_blank"
                  >
                    Zonal Senior Girls Tennis Championship 2017-18{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_53.pdf"
                    target="_blank"
                  >
                    Bio Box Office, DPS Dwarka, Sec-3{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_56.pdf"
                    target="_blank"
                  >
                    Ozone Heroes Campaign Quiz Competition{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_55.pdf"
                    target="_blank"
                  >
                    The Heritage School, Rohini{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_57.pdf"
                    target="_blank"
                  >
                    Inter-School Competition, Modern School{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_59.pdf"
                    target="_blank"
                  >
                    Poster Making Competition - Chinmaya Vidyalaya{" "}
                  </Link>
                </li>
              </ul>
              <h6>2016-2017</h6>
              <ul className="list">
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_24.pdf"
                    target="_blank"
                  >
                    Mini Basket ball Tournament- Zonals at DPS Vasant Kunj{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_25.pdf"
                    target="_blank"
                  >
                    Expressions 2016 - Army Public School, Shankar Vihar{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_26.pdf"
                    target="_blank"
                  >
                    Confluence 2016 - AFGJI{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_27.pdf"
                    target="_blank"
                  >
                    22nd Fr. Peter Mermier Memorial Football Tournament{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_28.pdf"
                    target="_blank"
                  >
                    Vibrations-Birla Vidya Niketan, Pushp Vihar{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_29.pdf"
                    target="_blank"
                  >
                    AFWWA Declamation 2016{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_30.pdf"
                    target="_blank"
                  >
                    Zonal Athletics 2016-17{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_31.pdf"
                    target="_blank"
                  >
                    Zonal Level Science Exhibition{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_32.pdf"
                    target="_blank"
                  >
                    Zonal Level - Poster Making Competition{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_33.pdf"
                    target="_blank"
                  >
                    Air Force Quiz - 2016{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_34.pdf"
                    target="_blank"
                  >
                    On the Spot Painting Competition - Pragati Maidan{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_35.pdf"
                    target="_blank"
                  >
                    National Level Painting Competition "Japan On Canvas-2016"{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_37.pdf"
                    target="_blank"
                  >
                    Inter School Competition - Cambridge School, Sriniwas Puri{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_38.pdf"
                    target="_blank"
                  >
                    Annual Space Art Contest 2017{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_39.pdf"
                    target="_blank"
                  >
                    CBSE 0.1% Certificate for 2016 Class XII Examination{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_40.pdf"
                    target="_blank"
                  >
                    Powergrid Scholarship : Football{" "}
                  </Link>
                </li>
              </ul>
              <h6>2015-2016</h6>
              <ul className="list">
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_22.pdf"
                    target="_blank"
                  >
                    {" "}
                    The Indian National Olympiad in Informatics, 2016
                    (INOI-2016){" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_21.pdf"
                    target="_blank"
                  >
                    {" "}
                    Edison Convention 2015 - Delhi Public School RK Puram{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_20.pdf"
                    target="_blank"
                  >
                    {" "}
                    Mathematics Achievement{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_18.pdf"
                    target="_blank"
                  >
                    {" "}
                    WARP 2015 – Annual Computer Symposium , Delhi Public School,
                    Mathura Road{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_17.pdf"
                    target="_blank"
                  >
                    {" "}
                    Inter School Physics Fest “ Impulse 2K15” at AFBBS{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_15.pdf"
                    target="_blank"
                  >
                    {" "}
                    CBSE North Zone-1 Taekwondo Tournament{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_19.pdf"
                    target="_blank"
                  >
                    {" "}
                    Inter command AF Schools Championship 2015{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_13.pdf"
                    target="_blank"
                  >
                    {" "}
                    Bournvita Quiz Contest{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_12.pdf"
                    target="_blank"
                  >
                    {" "}
                    Navy Children School{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_11.pdf"
                    target="_blank"
                  >
                    {" "}
                    Navy Children School{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_10.pdf"
                    target="_blank"
                  >
                    {" "}
                    All Delhi Open Skating Championship{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_9.pdf"
                    target="_blank"
                  >
                    {" "}
                    Zonal Mini Basketball Tournament - DPS, Vasant Kunj{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_8.pdf"
                    target="_blank"
                  >
                    {" "}
                    EXPEDIENTE- 2015 - Army Public School, Dhaula Kuan{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/bny-wcp-2407181020-1926763464.pdf"
                    target="_blank"
                  >
                    {" "}
                    Saraswati Memorial Annual Inter School Festival- New Era Public
                    School{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_7.pdf"
                    target="_blank"
                  >
                    {" "}
                    Quiz Thailand 2015{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_6.pdf"
                    target="_blank"
                  >
                    {" "}
                    NCC (CATC) Camp{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_5.pdf"
                    target="_blank"
                  >
                    {" "}
                    Taekwondo-Siddhartha Kumar Singh{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_4.pdf"
                    target="_blank"
                  >
                    {" "}
                    Sarv Sahodaya Inter School Competition at Bloom Public
                    School{" "}
                  </Link>{" "}
                </li>
              </ul>
              <h6>2014-2015</h6>
              <ul className="list">
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_1.pdf"
                    target="_blank"
                  >
                    Inter School Social Science Fest - MERAK I
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/bny-wcp-2407181020-0767510162.pdf"
                    target="_blank"
                  >
                    AFWWA DECLAMATION
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/bny-wcp-2407181020-1268800324.pdf"
                    target="_blank"
                  >
                    Ordin@trix’14 at Tagore International School
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/bny-wcp-2407181020-0648190667.pdf"
                    target="_blank"
                  >
                    Bloom Fest at Bloom Public School
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/bny-wcp-2407181020-0566224655.pdf"
                    target="_blank"
                  >
                    Science Fest at Bluebells International School
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/bny-wcp-2407181020-1486670854.pdf"
                    target="_blank"
                  >
                    MOD Debate - Modern School, Vasant Vihar
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/bny-wcp-2407181024-0252035924.pdf"
                    target="_blank"
                  >
                    Inter School Computer Competition, Amity International School
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_2.pdf"
                    target="_blank"
                  >
                    QUESTA-2014 , Mount Carmel School
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Achievements/contentpage_105_52_3.pdf"
                    target="_blank"
                  >
                    Sarv Sahodaya Girls (Junior) Soccer Tournament
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AchievementsData;
